<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
  @if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
  }

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <mat-icon>close</mat-icon>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-2">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="orderId" id="orderId" type="number" pInputText (blur)="onOrderIdChange()">
            <label for="orderId">OrderId</label>
            @for (validation of validationMessages.orderId; track validation) {
              <span>
                @if (form1.get('orderId').hasError(validation.type) && (form1.get('orderId').dirty || form1.get('orderId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>



        <!--<div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <app-task-reservation-select> </app-task-reservation-select>
        </span>
      </div>-->
    </div>

    <div class="row">
      <div class="col-lg-2">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown dropdownIcon="fa fa-caret-down" class="w-100" [options]="moveReasons" formControlName="moveReason"
          optionLabel="name" optionValue="value" placeholder="Move Reasons"></p-dropdown>
          <label for="Move Reasons">Move Reasons</label>
          @for (validation of validationMessages.moveReason; track validation) {
            <span>
              @if (form1.get('moveReason').hasError(validation.type) && (form1.get('moveReason').dirty || form1.get('moveReason').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>

    <div class="row">
      <div class="mb-2">
        <div class="title fw-bold fs-6">Source Reservation Details</div>
      </div>
      <!--<div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <p-dropdown dropdownIcon="fa fa-caret-down" [options]="properties" formControlName="scrShortTermRentalId" optionLabel="propertyCode"
          optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode" [showClear]="false"
          placeholder="Select Property">
        </p-dropdown>
        <label for="Select Property">Select Property</label>
        <span *ngFor="let validation of validationMessages.scrShortTermRentalId">
          <small class="p-invalid"
            *ngIf="form1.get('scrShortTermRentalId').hasError(validation.type) && (form1.get('scrShortTermRentalId').dirty || form1.get('scrShortTermRentalId').touched)">{{validation.message}}
          </small>
        </span>
      </span>
    </div>-->

    <div class="col-lg-4">
      <span class="p-float-label required-field w-100 mb-3">
        <p-dropdown dropdownIcon="fa fa-caret-down" class="w-100" [options]="orderReservations"
          formControlName="srcReservationId" optionLabel="displayLabel" optionValue="reservationId"
          [filter]="true" filterBy="displayLabel" placeholder="Select Source Reservation"
          (onChange)="onSourceReservationChange($event)">
        </p-dropdown>
        <label for="srcReservationId">Source ReservationId</label>
        <span>
          @if (isSrcReservationId) {
            <small class="p-invalid">Source reservation is required
            </small>
          }
        </span>
        @for (validation of validationMessages.srcReservationId; track validation) {
          <span>
            @if (form1.get('srcReservationId').hasError(validation.type) && (form1.get('srcReservationId').dirty || form1.get('srcReservationId').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-2">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="srcTotalNights" id="srcTotalNights" type="number" pInputText>
        <label for="srcTotalNights">Source TotalNights</label>
        @for (validation of validationMessages.srcTotalNights; track validation) {
          <span>
            @if (form1.get('srcTotalNights').hasError(validation.type) && (form1.get('srcTotalNights').dirty || form1.get('srcTotalNights').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <!--<div class="col-lg-2">
    <span class="p-float-label required-field w-100 mb-3">
      <p-dropdown dropdownIcon="fa fa-caret-down" [options]="properties" formControlName="destShortTermRentalId" optionLabel="propertyCode"
        optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode" [showClear]="false"
        placeholder="Select Property">
      </p-dropdown>
      <label for="Select Property">Select Property</label>
      <span *ngFor="let validation of validationMessages.destShortTermRentalId">
        <small class="p-invalid"
          *ngIf="form1.get('destShortTermRentalId').hasError(validation.type) && (form1.get('destShortTermRentalId').dirty || form1.get('destShortTermRentalId').touched)">{{validation.message}}
        </small>
      </span>
    </span>
  </div>-->
</div>

<div class="row">

  <div class="col-lg-2">
    <span class="p-float-label required-field w-100 mb-3">
      <p-calendar [showTime]="true" hourFormat="12" formControlName="srcMoveDate" id="srcMoveDate"
      appendTo="body"></p-calendar>
      <label for="srcMoveDate">Source Move Date Time</label>
      @for (validation of validationMessages.srcMoveDate; track validation) {
        <span>
          @if (form1.get('srcMoveDate').hasError(validation.type) && (form1.get('srcMoveDate').dirty || form1.get('srcMoveDate').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>

  <div class="col-lg-2">
    <span class="p-float-label required-field w-100 mb-3">
      <p-inputNumber formControlName="srcRatePN" id="srcRatePN" mode="currency" currency="USD" [locale]="'en-US'"></p-inputNumber>
      <label for="srcRatePN">Source RatePN</label>
      @for (validation of validationMessages.srcRatePN; track validation) {
        <span>
          @if (form1.get('srcRatePN').hasError(validation.type) && (form1.get('srcRatePN').dirty || form1.get('srcRatePN').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>

  <div class="col-lg-2">
    <span class="p-float-label w-100 mb-3">
      <p-dropdown dropdownIcon="fa fa-caret-down" class="w-100" [options]="hksPaidBys"
        formControlName="srcHskPaidBy" optionLabel="name" optionValue="value"
      placeholder="Source HskPaidBy"></p-dropdown>
      <label for="srcHskPaidBy">Source HskPaidBy</label>
      @for (validation of validationMessages.srcHskPaidBy; track validation) {
        <span>
          @if (form1.get('srcHskPaidBy').hasError(validation.type) && (form1.get('srcHskPaidBy').dirty || form1.get('srcHskPaidBy').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
</div>

<div class="row">
  <div class="col-lg-2">
    <span class="p-float-label required-field w-100 mb-3">
      <p-inputNumber formControlName="srcHskFee" id="srcHskFee" mode="currency" currency="USD" [locale]="'en-US'"></p-inputNumber>
      <label for="srcHskFee">Source HskFee</label>
      @for (validation of validationMessages.srcHskFee; track validation) {
        <span>
          @if (form1.get('srcHskFee').hasError(validation.type) && (form1.get('srcHskFee').dirty || form1.get('srcHskFee').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
</div>

<div>
  <div class="my-2">
    <div class="title fw-bold fs-6">Destination Reservation Details</div>
  </div>
  <div class="row">
    <div class="col-lg-4">
      <span class="p-float-label required-field w-100 mb-3">
        <p-dropdown dropdownIcon="fa fa-caret-down" class="w-100" [options]="orderReservations"
          formControlName="destReservationId" optionLabel="displayLabel" optionValue="reservationId"
          [filter]="true" filterBy="displayLabel" placeholder="Select Destination Reservation"
          (onChange)="onDestinationReservationChange($event)">
        </p-dropdown>
        <label for="destReservationId">Destination ReservationId</label>
        <span>
          @if (isDestReservationId) {
            <small class="p-invalid">Destination reservation is required
            </small>
          }
        </span>
        @for (validation of validationMessages.destReservationId; track validation) {
          <span>
            @if (form1.get('destReservationId').hasError(validation.type) && (form1.get('destReservationId').dirty || form1.get('destReservationId').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-2">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="destTotalNights" id="destTotalNights" type="number" pInputText>
        <label for="destTotalNights">Destination TotalNights</label>
        @for (validation of validationMessages.destTotalNights; track validation) {
          <span>
            @if (form1.get('destTotalNights').hasError(validation.type) && (form1.get('destTotalNights').dirty || form1.get('destTotalNights').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
  </div>

  <div class="row">

    <div class="col-lg-2">
      <span class="p-float-label required-field w-100 mb-3">
        <p-calendar [showTime]="true" hourFormat="12" formControlName="destMoveDate" id="destMoveDate"
        appendTo="body"></p-calendar>
        <label for="destMoveDate">Destination Move Date Time</label>
        @for (validation of validationMessages.destMoveDate; track validation) {
          <span>
            @if (form1.get('destMoveDate').hasError(validation.type) && (form1.get('destMoveDate').dirty || form1.get('destMoveDate').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-2">
      <span class="p-float-label required-field w-100 mb-3">
        <p-inputNumber formControlName="destRatePN" id="destRatePN" mode="currency" currency="USD" [locale]="'en-US'"></p-inputNumber>
        <label for="destRatePN">Destination RatePN</label>
        @for (validation of validationMessages.destRatePN; track validation) {
          <span>
            @if (form1.get('destRatePN').hasError(validation.type) && (form1.get('destRatePN').dirty || form1.get('destRatePN').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-2">
      <span class="p-float-label w-100 mb-3">
        <p-dropdown dropdownIcon="fa fa-caret-down" class="w-100" [options]="hksPaidBys"
          formControlName="destHskPaidBy" optionLabel="name" optionValue="value"
        placeholder="Destination HskPaidBy"></p-dropdown>
        <label for="destHskPaidBy">Destination HskPaidBy</label>
        @for (validation of validationMessages.destHskPaidBy; track validation) {
          <span>
            @if (form1.get('destHskPaidBy').hasError(validation.type) && (form1.get('destHskPaidBy').dirty || form1.get('destHskPaidBy').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-2">
      <span class="p-float-label required-field w-100 mb-3">
        <p-inputNumber formControlName="destHskFee" id="destHskFee" mode="currency" currency="USD" [locale]="'en-US'"></p-inputNumber>
        <label for="destHskFee">Destination HskFee</label>
        @for (validation of validationMessages.destHskFee; track validation) {
          <span>
            @if (form1.get('destHskFee').hasError(validation.type) && (form1.get('destHskFee').dirty || form1.get('destHskFee').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
  </div>
</div>

<div>
  <div class="my-2">
    <div class="title fw-bold fs-6">Additional Details</div>
  </div>
  @if (!guestMoveId) {
    <div class="row">
      <div class="col-lg-6 mb-3">
        <p-checkbox formControlName="copySrcInvoice" [binary]="true" inputId="copySrcInvoice"
        label="Copy Source Invoice to Destination"></p-checkbox>
      </div>
    </div>
  }
  <div class="row">
    <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <textarea formControlName="opsNotes" id="opsNotes" [rows]="3" pInputTextarea></textarea>
        <label for="opsNotes">Options Notes</label>
        @for (validation of validationMessages.opsNotes; track validation) {
          <span>
            @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
  </div>
</div>
</div>

<!-- RU Sync Response -->
@if (ruSyncResult?.hasData) {
  <div class="ru-sync-result mt-3">
    <hr>
      <div class="my-2">
        <div class="title fw-bold fs-6">RU Sync Result</div>
      </div>
      <div class="row">
        <div class="col-lg-12 mb-2">
          <div class="ru-sync-status" [ngClass]="{'ru-sync-error': ruSyncResult.isError, 'ru-sync-success': !ruSyncResult.isError}">
            <i class="pi" [ngClass]="{'pi-check-circle': !ruSyncResult.isError, 'pi-exclamation-triangle': ruSyncResult.isError}"></i>
            <span class="ms-2">{{ruSyncResult.message}}</span>
          </div>
        </div>
      </div>
      @if (ruSyncResult.requestXml) {
        <div class="row">
          <div class="col-lg-12 mb-2">
            <p-panel header="RU Request XML" [toggleable]="true" [collapsed]="true">
              <pre class="ru-xml-content">{{ruSyncResult.requestXml}}</pre>
            </p-panel>
          </div>
        </div>
      }
      @if (ruSyncResult.responseXml) {
        <div class="row">
          <div class="col-lg-12 mb-2">
            <p-panel header="RU Response XML" [toggleable]="true" [collapsed]="true">
              <pre class="ru-xml-content">{{ruSyncResult.responseXml}}</pre>
            </p-panel>
          </div>
        </div>
      }
    </div>
  }

  <hr>
    <div class="row m-0">
      <div class="col-lg-12">
        <div class="btn-group">
          <div class="button-group">
            @if (guestMoveId) {
              <button pButton class="p-button-outlined p-button-secondary"
              [disabled]="formLoading" (click)="onSyncRu()">Sync RU</button>
            }
            @if (guestMoveId) {
              <button pButton class="btn-delete p-button-outlined p-button-danger"
              [disabled]="formLoading" (click)="onFormDelete()">Delete Guest Move</button>
            }
          </div>

          <div class="button-group">
            <button pButton class="btn-cancel p-button-text" [disabled]="formLoading" [mat-dialog-close]="formLoading ? null : true">Cancel</button>
            @if (!guestMoveId) {
              <button pButton class="btn-addt p-button" [disabled]="formLoading" (click)="formAdd()">
                @if (formLoading) { <i class="pi pi-spin pi-spinner mr-1"></i> } Add Guest Move
              </button>
            }

            @if (guestMoveId) {
              <button pButton class="btn-upt p-button" [disabled]="formLoading" (click)="formUpdate()">
                @if (formLoading) { <i class="pi pi-spin pi-spinner mr-1"></i> } Update Guest Move
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>